var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.000000, -900.000000) translate(0.000000, 573.000000) translate(18.000000, 56.000000) translate(1.000000, 98.000000) translate(1.000000, 174.000000)",
    stroke: "currentColor",
    strokeWidth: 0.95,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0837772,14.2616848 L1.42495248,14.2616848 C0.637877492,14.2616848 -4.74999996e-05,13.6232848 -4.74999996e-05,12.8366848 L-4.74999996e-05,1.42528498 C-4.74999996e-05,0.637734992 0.637877492,0.000284999996 1.42495248,0.000284999996 L21.0837772,0.000284999996 C21.8708522,0.000284999996 22.5087772,0.637734992 22.5087772,1.42528498 L22.5087772,12.8366848 C22.5087772,13.6232848 21.8708522,14.2616848 21.0837772,14.2616848 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0305472,0.498274994 L12.5191473,8.93142489 C11.8835974,9.49477488 10.9274224,9.49382488 10.2932974,8.93047489 L0.606622492,0.322049996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3397174 7.17838991L0.606717492 13.6041898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8445372 13.4749423L14.3167373 7.24294241"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.73511fa2c443476b5c1443cb186d2856.svg";
export { ForwardRef as ReactComponent };